import { object, string } from 'yup';
import i18n from '../../../../i18n';

// Types
import { EditExternalCompanyFormType } from './types';

export const EditExternalCompanyFormSchema =
  object<EditExternalCompanyFormType>({
    companyName: string().required(() => i18n.t('validation:required')),
  });
